module.exports = "/_next/static/images/T2-fc6b981ca04205462791a93aaab3a5e9.png";